import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  DateTimeInput,
  required,
  SelectInput,
} from "react-admin";
import { CustomToolbar, Title } from "../../shared/components/index.js";
import { PROMOTION_STATUSES } from "@local/constants/index.js";

const editPromotion = () => {
  const renderOptionText = (record) => (
    <span key={record.id}>
      <img
        src={record.url}
        alt={record.name}
        width={15}
        height={15}
        style={{ marginRight: "5px" }}
      />
      {record.name}
    </span>
  );

  return (
    <Edit
      title={<Title source="title" />}
      redirect="show"
      mutationMode="pessimistic"
    >
      <SimpleForm toolbar={<CustomToolbar />}>
        <ReferenceInput source="file_id" reference="File">
          <AutocompleteInput
            sx={{
              width: "20%",
              "@media (max-width:900px)": {
                width: "100%",
              },
            }}
            inputText={(record) => record.name}
            optionText={renderOptionText}
            optionValue="id"
            debounce={10}
            validate={[required()]}
            filterToQuery={(searchText) => ({ name: searchText })}
          />
        </ReferenceInput>
        <TextInput
          multiline
          sx={{
            width: "30%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          rows={4}
          source="title"
          inputProps={{ maxLength: 255 }}
          validate={[required()]}
        />
        <DateTimeInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="start_date"
          defaultValue={new Date()}
          validate={[required()]}
        />
        <DateTimeInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="end_date"
          defaultValue={new Date()}
          validate={[required()]}
        />
        <TextInput
          sx={{
            width: "30%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="text"
          multiline
          rows={4}
          fullWidth
          validate={[required()]}
          inputProps={{ maxLength: 255 }}
        />
        <SelectInput
          sx={{
            width: "20%",
            "@media (max-width:900px)": {
              width: "100%",
            },
          }}
          source="status"
          validate={[required()]}
          choices={Object.keys(PROMOTION_STATUSES).map((status) => ({
            id: status,
            name: `resources.Promotion.source.status.${status}`,
          }))}
        />
      </SimpleForm>
    </Edit>
  );
};

export default editPromotion;
